const apiKeys = {
  headerButtons: {
    create: 'צור',
  },
  table: {
    headers: {
      alias: 'שם',
      createdAt: 'נוצר בתאריך',
      accessTokenExpiration: 'תפוגת סשן',
      permissions: 'הרשאות',
      editable: 'ניתן לעריכה',
    },
    actions: {
      delete: 'מחק',
      generateToken: 'צור טוקן',
    },
    expiration: {
      default: 'ברירת מחדל',
    },
    filters: {
      editable: {
        label: 'ניתן לעריכה',
        isEditable: 'ניתן לעריכה',
        isNotEditable: 'לא ניתן לעריכה',
      },
    },
    permissions: {
      all: 'גישה מלאה',
    },
    editable: {
      yes: 'כן',
      no: 'לא',
    },
  },
  create: {
    title: 'צור מפתח API',
    error: 'יצירת מפתח API נכשלה',
    unlimitedWarning: 'טוקנים ללא הגבלה נשארים פעילים עד למחיקה. מומלץ להגדיר תקופת תפוגה.',
    tabs: {
      info: 'מידע',
      permissions: 'הרשאות',
    },
    expirationUnits: {
      minutes: 'דקות',
      hours: 'שעות',
      days: 'ימים',
      unlimited: 'ללא הגבלה',
    },
    fields: {
      alias: 'שם',
      expiresAt: 'תפוגת סשן',
    },
  },
  newSecretModal: {
    title: 'מפתח סודי חדש',
    subtitle: 'העתק את המפתח הסודי ללוח ושמור אותו במקום בטוח.',
    warning: 'שים לב: לאחר סגירת החלון לא תוכל לצפות שוב במפתח הסודי הזה.',
    secretKeyLabel: 'מפתח סודי',
    copy: 'העתק',
    copySuccess: 'הועתק ללוח',
    copyError: 'העתקה ללוח נכשלה',
    done: 'סיום',
  },
  delete: {
    success: 'מפתח API נמחק',
    error: 'מחיקת מפתח API נכשלה',
    confirmModal: {
      title: 'מחיקת מפתח API',
      body: 'האם אתה בטוח שברצונך למחוק את "{{ alias }}"? כל הטוקנים הפעילים שנוצרו ממפתח זה יפסיקו לעבוד מיד.',
      bodyMany: 'האם אתה בטוח שברצונך למחוק {{ count }} מפתחות API? כל הטוקנים הפעילים שנוצרו ממפתחות אלו יפסיקו לעבוד מיד.',
      confirm: 'מחק',
    },
  },
  edit: {
    title: 'עריכת "{{ alias }}"',
    success: 'מפתח API עודכן',
    error: 'עדכון מפתח API נכשל',
  },
  generateToken: {
    title: 'הזן מפתח סודי - {{ alias }}',
    subTitle: 'הזן את המפתח הסודי ולחץ על צור כדי לייצר טוקן וקוד קצר.',
    successTitle: 'טוקן API וקוד קצר חדשים',
    submit: 'צור',
    cancel: 'ביטול',
    done: 'סיום',
    copy: 'העתק',
    copySuccess: 'הועתק ללוח',
    copyError: 'העתקה ללוח נכשלה',
    error: 'יצירת טוקן נכשלה',
    instructions: 'הדבק את ה-Client Secret השמור שלך כדי לייצר טוקן גישה חדש.',
    tokenWarning: 'שים לב: לאחר סגירת החלון לא תוכל לצפות שוב בטוקן זה.',
    shortCodeWarning: 'שים לב: לאחר סגירת החלון לא תוכל לצפות שוב בקוד הקצר הזה.',
    fields: {
      clientId: 'Client ID',
      clientSecret: 'Client Secret',
      clientSecretPlaceholder: 'הדבק את המפתח הסודי',
      token: 'טוקן גישה',
      shortCode: 'קוד קצר',
      expiration: 'תוקף',
      tokenInfo: 'העתק את הטוקן ללוח ושמור אותו במקום בטוח.',
      shortCodeInfo: 'העתק את הקוד הקצר ללוח ושמור אותו במקום בטוח.',
    },
  },
};

export default apiKeys;
